import React from 'react';
import PropTypes from 'prop-types';
import useSectionStyles from './sectionstyles';

import { MANUAL_AUTOFINALIZE_SETTING_NAMES as AUTOFINALIZATION_OPTIONS } from '../../../services/contractmanagementservice';

const toAutofinalizationOptionsLookup = arr => {
  return arr.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.name]: curr.encounterCount
    }
  }, {});
};

const ManualAutofinalizationSection = ({
  contractId,
  autofinalizeOptions,
  boundActions
}) => {
  const optionsLookup = toAutofinalizationOptionsLookup(autofinalizeOptions);

  const first = `${AUTOFINALIZATION_OPTIONS.NO_DXES} (${optionsLookup[AUTOFINALIZATION_OPTIONS.NO_DXES]})`;
  const second = `${AUTOFINALIZATION_OPTIONS.NO_MA_HCCS} (${optionsLookup[AUTOFINALIZATION_OPTIONS.NO_MA_HCCS]})`;
  const third = `${AUTOFINALIZATION_OPTIONS.NO_NEW_MA_HCCS} (${optionsLookup[AUTOFINALIZATION_OPTIONS.NO_NEW_MA_HCCS]})`;

  const noDxesContent = first;
  const noDxesNoMAContent = `${first} ${second}`;
  const noDxesNoMANoNewMAContent = `${first} ${second} ${third}`;

  const classes = useSectionStyles();

  return (
    <div className={classes.manualAutofinalization}>
      <h5 style={{ marginTop: '0' }}><u>Manual Autofinalization</u></h5>
      <div>
        <button onClick={() => {
          boundActions.manualAutofinalize(
            contractId,
            [{ name: AUTOFINALIZATION_OPTIONS.NO_DXES, isChecked: true }]
          );
        }}>
          <span>
            {noDxesContent}
          </span>
        </button>
      </div>

      <div>
        <button onClick={() => {
          boundActions.manualAutofinalize(
            contractId,
            [
              { name: AUTOFINALIZATION_OPTIONS.NO_DXES, isChecked: true},
              { name: AUTOFINALIZATION_OPTIONS.NO_MA_HCCS, isChecked: true }
            ]
          );
        }}>
          <span>
            {noDxesNoMAContent}
          </span>
        </button>
      </div>

      <div>
        <button onClick={() => {
          boundActions.manualAutofinalize(
            contractId,
            [
              { name: AUTOFINALIZATION_OPTIONS.NO_DXES, isChecked: true },
              { name: AUTOFINALIZATION_OPTIONS.NO_MA_HCCS, isChecked: true },
              { name: AUTOFINALIZATION_OPTIONS.NO_NEW_MA_HCCS, isChecked: true }
            ]
          );
        }}>
          <span>
            {noDxesNoMANoNewMAContent}
          </span>
        </button>
      </div>
    </div>
  );
};

ManualAutofinalizationSection.propTypes = {
  contractId: PropTypes.number.isRequired
};

export default ManualAutofinalizationSection;
